export const offerPageHeader = {
  title: "Nasze Projekty",
  subtitle:
    "Odkryj gotowe szablony stron, które mogą transformować Twoją markę",
};

export const templatePreviewStrings = {
  backLabel: "← Wróć do ofert",
  aboutTitle: "O szablonie",
  featuresTitle: "Szablon zawiera:",
};

export const offerDetailsStrings = {
  interestedLabel: "Zainteresowana",
  closeLabel: "Zamknij",
  featuresTitle: "Co zawiera:",
  priceLabel: "Cena za projekt:",
};
